import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-371c1e3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "repository" }
const _hoisted_2 = { class: "repository__title" }
const _hoisted_3 = { class: "repository__desc" }
const _hoisted_4 = { class: "repository__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Controls = _resolveComponent("Controls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString($props.repositoryData.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString($props.repositoryData.text), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Controls, {
        repoStats: $props.repositoryData.stats,
        onRemoveStar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('removeStar'))),
        starred: $props.status
      }, null, 8, ["repoStats", "starred"])
    ])
  ]))
}